"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    ownerState,
    theme
  }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey.A100,
    ...(ownerState.color === 'inherit' && {
      '&::before': {
        backgroundColor: theme.palette.grey.A100
      }
    })
  }),
  bar: {
    borderRadius: 4
  },
  dashed: {
    backgroundSize: '10.8px 10.8px'
  },
  bar2Buffer: {
    opacity: 0.3
  },
  barColorPrimary: ({
    theme
  }) => ({
    backgroundColor: theme.palette.error.main
  }),
  dashedColorPrimary: ({
    theme
  }) => ({
    backgroundImage: `radial-gradient(${theme.palette.error.main} 0%, ${theme.palette.error.main} 16%, transparent 42%)`
  }),
  barColorSecondary: ({
    theme
  }) => ({
    backgroundColor: theme.palette.success.main
  }),
  dashedColorSecondary: ({
    theme
  }) => ({
    backgroundImage: `radial-gradient(${theme.palette.success.main} 0%, ${theme.palette.success.main} 16%, transparent 42%)`
  })
};
var _default = exports.default = {
  styleOverrides
};
